export const genderStatus = {
	MALE: 1,
	FEMALE: 2,
}
export const leadStatus = {
	NEW: 1,
	QUALIFIED: 2,
	PROPOSITION: 3,
	WON: 4,
	FAIL: 5,
}
export const markStatus = {
	NORMAL: 1,
	MEDIUM: 2,
	HIGH: 3,
}
export const projectStatus = {
	TKTRANGCHU: 1,
	CHODUYETTC: 2,
	THIETKETRANGTRONG: 3,
	CHODUYETBO: 4,
	FRONTEND: 5,
	BACKEND: 6,
	FBPREVIEW: 7,
	PUSHNGHIEMTHU: 8,
	DONE: 9,
}
export const revenueStatus = {
	DANGTHUCHIEN: 1,
	THUTRONGTUAN: 2,
	DATHU: 3,
	THUTRONGTHANG: 4,
	SAPDONG: 5,
}
export const dataStatusRevenue = [
	{
		value: revenueStatus.DANGTHUCHIEN,
		name: "Đang thực hiện",
	},
	{
		value: revenueStatus.THUTRONGTUAN,
		name: "Thu trong tuần",
	},
	{
		value: revenueStatus.DATHU,
		name: "Đã thu",
	},
	{
		value: revenueStatus.THUTRONGTHANG,
		name: "Thu trong tháng",
	},
	{
		value: revenueStatus.SAPDONG,
		name: "Sắp đóng",
	},
];